module.exports = __webpack_public_path__ + "static/media/video-3.a209aab7.mp4";